var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2H9.5C8.4 2 7.5 2.9 7.5 4V16C7.5 17.1 8.4 18 9.5 18H18.5C19.6 18 20.5 17.1 20.5 16V4C20.5 2.9 19.6 2 18.5 2ZM18.5 16H9.5V4H18.5V16ZM3.5 15V13H5.5V15H3.5ZM3.5 9.5H5.5V11.5H3.5V9.5ZM10.5 20H12.5V22H10.5V20ZM3.5 18.5V16.5H5.5V18.5H3.5ZM5.5 22C4.4 22 3.5 21.1 3.5 20H5.5V22ZM9 22H7V20H9V22ZM14 22V20H16C16 21.1 15.1 22 14 22ZM5.5 6V8H3.5C3.5 6.9 4.4 6 5.5 6Z",
    fill: "#454B60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.603706a4d439e5986af36d96c76510dc.svg";
export { ForwardRef as ReactComponent };